import { styled } from 'stitches.config'
import { Proteins } from 'models/Pet'

export const SixRecipesRoot = styled('div', {
  background: '$accent-white',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  overflow: 'hidden',
})

export const SixRecipesContainer = styled('div', {
  width: '100%',
  paddingLeft: '$2',
  paddingRight: '$2',
  paddingTop: '$7',
  paddingBottom: '$7',

  display: 'flex',
  flexDirection: 'column',
  gap: '$2',
  margin: 'auto',
  maxWidth: '400px',

  '@mobile': {
    gap: '$6',
  },
  '@bp2': {
    maxWidth: '1000px',
  },
  '@bp4': {
    maxWidth: '100%',
  },
})

export const Recipe = styled('div', {
  width: '260px',
  height: '44px',
  paddingTop: '2px',

  borderRadius: '100px',
  display: 'flex',
  flexDirection: 'row',

  alignItems: 'center',
  color: '$accent-white',
  cursor: 'pointer',

  paddingLeft: '16px',
  paddingRight: '50px',
  justifyContent: 'flex-start',

  '@bp2': {
    paddingRight: '30px',
  },

  variants: {
    large: {
      true: {
        '@bp2': {
          paddingRight: 0,
          paddingLeft: 0,
          justifyContent: 'center',
        }
      },
      false: {
        
      },
    },
    type: {
      [Proteins.CHICKEN]: {
        background: '$tag-yellow-color',
        '&:hover': {
          background: '$tag-yellow-hover-color',
        },
      },
      [Proteins.BEEF]: {
        background: '$primary-500',
        '&:hover': {
          background: '$primary-400',
        },
      },
      [Proteins.LAMB]: {
        background: '$tag-dark-orange-color',
        '&:hover': {
          background: '$tag-dark-orange-hover-color',
        },
      },
      [Proteins.TURKEY]: {
        background: '$accent-black',
        '&:hover': {
          background: '$tertiary-1100',
        },
      },
      [Proteins.VENISON]: {
        background: '$tertiary-400',
        '&:hover': {
          background: '$tertiary-400',
          filter: 'brightness(1.20)'
        },
      },
      [Proteins.DUCK]: {
        background: '$primary-700',
        '&:hover': {
          background: '$primary-700',
          filter: 'brightness(1.20)'
        },
      },
    },
  },
})

export const RecipesContainer = styled('div', {
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'center',
  gap: '32px',
})

export const IconWrapper = styled('div', {
  variants: {
    large: {
      true: {
        display: 'block',
        '@bp2': {
          display: 'none'
        }
      }
    }
  }
})